<template>
  <div class="cycloid-pendulum-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>T = 2π√(L/g) | 振幅无关性$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Cycloid Rails (The "Checkers") -->
          <path :d="leftRail" fill="none" stroke="#555" stroke-dasharray="4" />
          <path :d="rightRail" fill="none" stroke="#555" stroke-dasharray="4" />

          <!-- Strings -->
          <line x1="200" y1="20" :x2="bobSmall.x" :y2="bobSmall.y" stroke="rgba(0, 210, 255, 0.4)" />
          <line x1="200" y1="20" :x2="bobLarge.x" :y2="bobLarge.y" stroke="rgba(255, 71, 87, 0.4)" />

          <!-- Bobs -->
          <circle :cx="bobSmall.x" :cy="bobSmall.y" r="8" fill="#00d2ff" />
          <circle :cx="bobLarge.x" :cy="bobLarge.y" r="8" fill="#ff4757" />

          <text x="50" y="30" fill="#00d2ff" font-size="8">小振幅</text>
          <text x="300" y="30" fill="#ff4757" font-size="8">大振幅</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>两个摆球始终同时回到平衡位置</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="reset">同步释放</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>普通的单摆在描述大振幅运动时并不等时（周期随振幅增加）。惠更斯发现，如果让摆线在两块**摆线形**挡板之间运动，摆球实际走过的路径也是一条摆线。在摆线路径上，重力的分量与路径长度成正比，使得运动具有完美的**等时性**。这是早期精准摆钟的核心原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CycloidPendulumViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      time: 0,
      timer: null
    }
  },
  computed: {
    leftRail() { return "M 200,20 Q 150,20 120,80"; },
    rightRail() { return "M 200,20 Q 250,20 280,80"; },
    bobSmall() {
       let theta = 0.3 * Math.cos(this.time * 2);
       return { x: 200 + 150*Math.sin(theta), y: 20 + 150*Math.cos(theta) };
    },
    bobLarge() {
       let theta = 1.0 * Math.cos(this.time * 2);
       // Note: In real cycloid pendulum, the string wraps/unwraps.
       // This is a simplified visual representation.
       return { x: 200 + 150*Math.sin(theta), y: 20 + 150*Math.cos(theta) };
    }
  },
  methods: {
    update() {
      this.time += 0.05;
      this.timer = requestAnimationFrame(this.update);
    },
    reset() { this.time = 0; }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.cycloid-pendulum-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
